// Dog Ebook Short - Essential Interactive Elements

// Body Condition Score functionality
document.addEventListener('DOMContentLoaded', function() {
  console.log('Dog Ebook Short loaded');
  
  // Initialize all interactive elements
  initBodyScore();
  initExerciseTracker();
  initActionChecklist();
  
  // Add scroll animations
  initScrollAnimations();
  
  // Initialize number animations
  initNumberAnimations();
});

// Body Condition Score
function initBodyScore() {
  const scoreButtons = document.querySelectorAll('.score-btn');
  const scoreTip = document.getElementById('score-tip');
  
  const scoreDescriptions = {
    '1': 'Emaciated: Ribs, spine, and hip bones are easily visible from a distance.',
    '2': 'Very Thin: Ribs, spine, and hip bones are easily felt and visible.',
    '3': 'Thin: Ribs are easily felt with minimal fat covering.',
    '4': 'Ideal: Ribs are easily felt with a slight fat cover.',
    '5': 'Ideal: Ribs are easily felt without excess fat.',
    '6': 'Overweight: Ribs are felt with difficulty under a heavy fat cover.',
    '7': 'Heavy: Ribs are very difficult to feel under a thick fat cover.',
    '8': 'Obese: Ribs cannot be felt under a very thick fat cover.',
    '9': 'Morbidly Obese: Massive fat deposits on chest, spine, and base of tail.'
  };
  
  scoreButtons.forEach(button => {
    button.addEventListener('click', function() {
      const score = this.getAttribute('data-score');
      
      // Remove active class from all buttons
      scoreButtons.forEach(btn => btn.classList.remove('active'));
      
      // Add active class to clicked button
      this.classList.add('active');
      
      // Update tip text
      if (scoreTip) {
        scoreTip.textContent = scoreDescriptions[score] || 'Click a number to see description';
        scoreTip.style.animation = 'fadeIn 0.3s ease';
      }
      
      // Add visual feedback
      this.style.animation = 'pulse 0.6s ease';
      setTimeout(() => {
        this.style.animation = '';
      }, 600);
    });
  });
}

// Exercise Tracker
function initExerciseTracker() {
  const dayButtons = document.querySelectorAll('.day');
  
  dayButtons.forEach(day => {
    day.addEventListener('click', function() {
      this.classList.toggle('active');
      
      // Add visual feedback
      if (this.classList.contains('active')) {
        this.style.animation = 'pulse 0.6s ease';
        setTimeout(() => {
          this.style.animation = '';
        }, 600);
        
        // Show encouragement
        showFloatingText(this, 'Great! 🐕');
      }
    });
  });
}

// Action Checklist
function initActionChecklist() {
  updateMiniProgress();
}

// Toggle action item
window.toggleAction = function(actionItem) {
  const checkbox = actionItem.querySelector('.action-checkbox');
  const textSpan = actionItem.querySelector('span');
  
  checkbox.classList.toggle('checked');
  actionItem.classList.toggle('completed');
  
  if (checkbox.classList.contains('checked')) {
    // Add celebration effect
    checkbox.style.animation = 'pulse 0.6s ease';
    setTimeout(() => {
      checkbox.style.animation = '';
    }, 600);
    
    // Show floating text
    showFloatingText(checkbox, '✅ Done!');
  }
  
  // Update progress
  updateMiniProgress();
};

// Update mini progress bar
function updateMiniProgress() {
  const totalItems = document.querySelectorAll('.action-item').length;
  const completedItems = document.querySelectorAll('.action-checkbox.checked').length;
  const percentage = Math.round((completedItems / totalItems) * 100);
  
  const progressText = document.getElementById('mini-progress');
  const progressFill = document.getElementById('mini-fill');
  
  if (progressText) {
    progressText.textContent = completedItems;
  }
  
  if (progressFill) {
    progressFill.style.width = percentage + '%';
  }
  
  // Celebration when all completed
  if (completedItems === totalItems && totalItems > 0) {
    setTimeout(() => {
      showCompletionCelebration();
    }, 500);
  }
}


// Show quick tip
window.showQuickTip = function() {
  const tips = [
    { title: '⚖️ Weight Check', text: 'Feel your dog\'s ribs - they should be easily felt but not visible. This is ideal!' },
    { title: '🏃‍♂️ Daily Walks', text: 'A consistent 30-minute walk beats sporadic weekend adventures every time.' },
    { title: '🥩 Protein Quality', text: 'Fresh, gently cooked proteins are more digestible than kibble. Quality over quantity!' },
    { title: '🐟 Omega-3 Benefits', text: 'Fish oil in food supports brain health, shiny coat, and immune function.' },
    { title: '💡 Portion Control', text: 'Many dog food bags overestimate portions. Start with less and adjust based on body condition.' }
  ];
  
  const randomTip = tips[Math.floor(Math.random() * tips.length)];
  
  const tipModal = document.createElement('div');
  tipModal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1003;
    animation: fadeIn 0.3s ease;
  `;
  
  tipModal.innerHTML = `
    <div style="
      background: white;
      border-radius: 16px;
      padding: 2rem;
      max-width: 400px;
      width: 90%;
      text-align: center;
      box-shadow: 0 20px 25px rgba(0,0,0,0.1);
      animation: slideUp 0.4s ease-out;
    ">
      <h4 style="
        font-size: 1.4rem;
        font-weight: 600;
        color: #e74c3c;
        margin-bottom: 1rem;
      ">${randomTip.title}</h4>
      <p style="
        font-size: 1rem;
        line-height: 1.6;
        color: #5a6c7d;
        margin-bottom: 1.5rem;
      ">${randomTip.text}</p>
      <button onclick="this.parentElement.parentElement.remove()" style="
        background: #e74c3c;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 0.75rem 1.5rem;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
      " onmouseover="this.style.background='#c0392b'" onmouseout="this.style.background='#e74c3c'">
        Got it! 🐾
      </button>
    </div>
  `;
  
  document.body.appendChild(tipModal);
  
  // Close FAB menu
  const fabMenu = document.getElementById('fab-menu');
  const fab = document.querySelector('.fab-main');
  if (fabMenu && fab) {
    fabMenu.classList.remove('active');
    fab.style.transform = 'scale(1)';
  }
};

// Show floating text animation
function showFloatingText(element, text) {
  const floatingText = document.createElement('div');
  floatingText.textContent = text;
  floatingText.style.cssText = `
    position: fixed;
    color: #28a745;
    font-weight: bold;
    font-size: 14px;
    pointer-events: none;
    z-index: 1000;
    animation: floatUp 2s ease-out forwards;
  `;
  
  const rect = element.getBoundingClientRect();
  floatingText.style.left = rect.left + (rect.width / 2) + 'px';
  floatingText.style.top = rect.top - 10 + 'px';
  floatingText.style.transform = 'translateX(-50%)';
  
  document.body.appendChild(floatingText);
  
  setTimeout(() => {
    floatingText.remove();
  }, 2000);
}

// Show completion celebration
function showCompletionCelebration() {
  // Create celebration particles
  for (let i = 0; i < 15; i++) {
    const particle = document.createElement('div');
    particle.innerHTML = ['🎉', '✨', '🐾', '❤️'][Math.floor(Math.random() * 4)];
    particle.style.cssText = `
      position: fixed;
      left: 50%;
      top: 50%;
      font-size: ${Math.random() * 20 + 15}px;
      pointer-events: none;
      z-index: 1001;
      animation: burstOut 1.5s ease-out forwards;
    `;
    particle.style.setProperty('--random-x', (Math.random() - 0.5) * 300 + 'px');
    particle.style.setProperty('--random-y', (Math.random() - 0.5) * 300 + 'px');
    
    document.body.appendChild(particle);
    
    setTimeout(() => {
      particle.remove();
    }, 1500);
  }
  
  // Show completion modal
  setTimeout(() => {
    const modal = document.createElement('div');
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1002;
      animation: fadeIn 0.3s ease;
    `;
    
    modal.innerHTML = `
      <div style="
        background: white;
        border-radius: 20px;
        padding: 3rem;
        max-width: 500px;
        width: 90%;
        text-align: center;
        box-shadow: 0 20px 25px rgba(0,0,0,0.1);
        animation: slideUp 0.4s ease-out;
      ">
        <h3 style="
          font-size: 1.8rem;
          font-weight: 600;
          color: #e74c3c;
          margin-bottom: 1rem;
        ">🎉 Amazing Work!</h3>
        <p style="
          font-size: 1.1rem;
          line-height: 1.6;
          color: #5a6c7d;
          margin-bottom: 1.5rem;
        ">You've completed all the high-impact actions for your dog's longevity!</p>
        <p style="
          font-size: 1rem;
          line-height: 1.6;
          color: #5a6c7d;
          margin-bottom: 2rem;
        ">Your pup is lucky to have such a caring parent. Keep up the great work!</p>
        <button onclick="this.parentElement.parentElement.remove()" style="
          background: #e74c3c;
          color: white;
          border: none;
          padding: 1rem 2rem;
          border-radius: 50px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        " onmouseover="this.style.background='#c0392b'" onmouseout="this.style.background='#e74c3c'">
          Continue Reading
        </button>
      </div>
    `;
    
    document.body.appendChild(modal);
  }, 800);
}

// Scroll animations
function initScrollAnimations() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animation = 'slideUp 0.6s ease forwards';
        entry.target.style.opacity = '1';
      }
    });
  }, observerOptions);
  
  // Observe factor cards
  document.querySelectorAll('.factor-card').forEach(card => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px)';
    observer.observe(card);
  });
  
  // Observe action cards
  document.querySelectorAll('.action-card').forEach(card => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px)';
    observer.observe(card);
  });
}

// Number Animation Function
function initNumberAnimations() {
  // Define animation targets and their final values
  const animationTargets = [
    {
      selector: '.stat-number',
      finalValue: (element) => {
        const text = element.textContent;
        if (text.includes('1.8')) return 1.8;
        if (text.includes('4')) return 4;
        return parseFloat(text) || 0;
      },
      duration: 1200, // Faster animation
      suffix: (element) => {
        const text = element.textContent;
        if (text.includes('1.8')) return '';
        if (text.includes('4')) return '';
        return '';
      }
    },
    {
      selector: '.impact-number',
      finalValue: (element) => {
        const text = element.textContent;
        if (text.includes('25%')) return 25;
        if (text.includes('18%')) return 18;
        if (text.includes('30min')) return 30; // Animate 30min
        if (text.includes('EPA + DHA')) return null; // Skip text values
        return parseFloat(text) || 0;
      },
      duration: 1000, // Faster animation
      suffix: (element) => {
        const text = element.textContent;
        if (text.includes('%')) return '%';
        if (text.includes('30min')) return 'min';
        return '';
      }
    }
  ];

  // Create intersection observer for scroll-triggered animations
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const config = animationTargets.find(target => 
          element.matches(target.selector)
        );
        
        if (config) {
          const finalValue = config.finalValue(element);
          if (finalValue !== null) {
            animateNumber(element, 0, finalValue, config.duration, config.suffix(element));
            observer.unobserve(element); // Only animate once
          }
        }
      }
    });
  }, {
    threshold: 0.5,
    rootMargin: '0px 0px -100px 0px'
  });

  // Observe all number elements
  animationTargets.forEach(config => {
    document.querySelectorAll(config.selector).forEach(element => {
      observer.observe(element);
    });
  });
}

// Animate number counting up
function animateNumber(element, start, end, duration, suffix = '') {
  const startTime = performance.now();
  const isDecimal = end % 1 !== 0;
  
  function updateNumber(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    
    // Easing function for smooth animation
    const easeOutQuart = 1 - Math.pow(1 - progress, 4);
    const current = start + (end - start) * easeOutQuart;
    
    if (isDecimal) {
      element.textContent = current.toFixed(1) + suffix;
    } else {
      element.textContent = Math.floor(current) + suffix;
    }
    
    if (progress < 1) {
      requestAnimationFrame(updateNumber);
    } else {
      // Ensure final value is exact
      if (isDecimal) {
        element.textContent = end.toFixed(1) + suffix;
      } else {
        element.textContent = end + suffix;
      }
    }
  }
  
  requestAnimationFrame(updateNumber);
}

// Add CSS animations to head if not already present
if (!document.querySelector('#dog-ebook-short-animations')) {
  const style = document.createElement('style');
  style.id = 'dog-ebook-short-animations';
  style.textContent = `
    @keyframes floatUp {
      0% {
        opacity: 1;
        transform: translateY(0);
      }
      100% {
        opacity: 0;
        transform: translateY(-50px);
      }
    }
    
    @keyframes burstOut {
      0% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(0);
      }
      50% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
      100% {
        opacity: 0;
        transform: translate(calc(-50% + var(--random-x)), calc(-50% + var(--random-y))) scale(0.5);
      }
    }
    
    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.1); }
    }
    
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    
    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes numberGlow {
      0%, 100% { 
        text-shadow: 0 0 5px rgba(231, 76, 60, 0.3);
        transform: scale(1);
      }
      50% { 
        text-shadow: 0 0 15px rgba(231, 76, 60, 0.6);
        transform: scale(1.05);
      }
    }
  `;
  document.head.appendChild(style);
}
